import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalSto } from 'components/sto';

import { ReactComponent as SessionExpiresWarningIcon } from '../../assets/icons/session-expires-warning.svg';

const SessionWarningModal = (props) => (
    <ModalSto
        buttonSize="medium"
        countDown={props.countdown}
        okText="keep.me.logged.in.button"
        onOk={props.onOk}
        visible={props.visible}
        wrapClassName="session-warning-modal"
    >
        <React.Fragment>
            <SessionExpiresWarningIcon />
            <p>
                <FormattedMessage id="session.expires.warning.message" values={{ countdown: props.countDown }} />
            </p>
        </React.Fragment>
    </ModalSto>
);

export default SessionWarningModal;
